// extracted by mini-css-extract-plugin
export default {"list":"AddItemsAndGroupsList_list__kToSg"};